function getStrFromSlugStringUtil (str) {
  return str.toLowerCase().replace(/-/g, ' ')
}

export {
  getStrFromSlugStringUtil
}
